import React, { useState } from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const SHOW_LIMIT = 4;

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const AnchorNavigation = ({ anchors = [] }) => {
    const [showAll, setShowAll] = useState(false);
    const items = anchors ?? [];
    const hasMore = items.length > SHOW_LIMIT;
    const visible = showAll ? items : items.slice(0, SHOW_LIMIT);

    return (
        <div className='layout-container layout-site-outer-padding bg-white py-40'>
            <div className='col-wrapper'>
                <p className='type-style-eyebrow text-text-primary col-padding mb-16'>Contents</p>
                <div className='flex flex-col gap-8 col-padding md:w-5/12'>
                    <div className='flex flex-col'>
                        {visible.map((anchor, idx) => (
                            <a
                                className='flex items-center py-12 border-t border-border-default type-style-body-small'
                                href={`#${anchor.slug}`}
                                key={anchor.slug}>
                                <span className='w-32 shrink-0 text-text-tertiary'>
                                    {String(idx + 1).padStart(2, '0')}
                                </span>
                                <span className='flex-1 min-w-0 text-text-primary'>
                                    {anchor.label}
                                </span>
                            </a>
                        ))}
                    </div>
                    {hasMore && (
                        <button
                            className='type-style-body-small text-text-secondary text-left'
                            onClick={() => setShowAll((v) => !v)}
                            type='button'>
                            {showAll ? 'See Less' : 'See All'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    anchors: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        slug: PropTypes.string.isRequired,
    })),
};

AnchorNavigation.propTypes = propTypes;

export default AnchorNavigation;
